import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";

import PerfectScrollbar from "perfect-scrollbar";

import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;
window.PerfectScrollbar = PerfectScrollbar;

library.add(fas, far, fab); // Add all icons to the library

const win = navigator.platform.indexOf("Win") > -1;
if (win && document.querySelector("#sidenav-scrollbar")) {
    const options = {
        damping: "0.5",
    };

    new PerfectScrollbar(document.querySelector("#sidenav-scrollbar"), options);
}

/**
 * We"ll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require("jquery");

    $(document).ready(function () {
        if ($("#is_store").is(":checked")) {
            $("#hours-container").removeClass("d-none");
        }

        $("#is_store").change(function (ev) {
            if ($("#is_store").is(":checked")) {
                $("#hours-container").removeClass("d-none");
            } else {
                $("#hours-container").addClass("d-none");
            }
        });

        $(".js-remove-email-domain").click(function (e) {
            e.preventDefault();
            $("#email-domain-field").detach();
        });
    });
} catch (e) {}
